export enum MessageSendAction {
  BROADCAST = 'broadcast',
}

export enum MessageReceivedEvent {
  ANALYSIS_START = 'analysisStart',
  ANALYSIS_END = 'analysisEnd',
  ANALYSIS_ERROR = 'analysisError',
  RECOMMENDATION_STATUS_CHANGE = 'recommendationStatusChange',
}

export type MessageReceived<T = unknown> = {
  event: MessageReceivedEvent;
  data: T;
}

export type MessageSent<T = unknown> = {
  action: MessageSendAction;
  payload: MessageReceived<T>;
  excludeSender: boolean;
}

export type AnalysisMessageData = {
  itpExecutionId: string;
}
